import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Coins, DotsThreeCircleVertical } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { ButtonMenu, FormatPrice, IconButton, Text } from '@reveni-io/reveni-ui'

import IssueRefundComboBox from './IssueRefundComboBox/IssueRefundComboBox'
import { refundMethodText, refundStatuses } from './constants'
import * as Styles from './styles'

const IssueRefundSelector = ({
  checked,
  onChange,
  refundMethod,
  allowIssueRefund,
  canEditIssueRefund,
  refundQuantity,
  currency,
  ordersWithRemainingAmount,
  isInstant,
  refundStatus,
  menuItems = [],
  exchangeForOrderExternalUrl,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if ((!allowIssueRefund && isInstant) || refundStatus === refundStatuses.completed || !refundStatus) return null

  return (
    <Styles.Container>
      <Styles.RefundTitle>
        <Text type="titleS">{t('Reembolso')}:</Text>
        {menuItems?.length > 0 && (
          <ButtonMenu
            stopPropagation
            menuItems={menuItems}
            renderButton={onClick => (
              <IconButton
                variant="text"
                onClick={onClick}
                icon={<DotsThreeCircleVertical size={24} weight="light" data-testid="issue-refund-menu" />}
              />
            )}
          />
        )}
      </Styles.RefundTitle>
      {ordersWithRemainingAmount ? (
        <Styles.RefundQuantity>
          {ordersWithRemainingAmount}{' '}
          {ordersWithRemainingAmount > 1
            ? t('transacciones con reembolso pendiente')
            : t('transacción con reembolso pendiente')}
        </Styles.RefundQuantity>
      ) : (
        <Styles.RefundQuantity negative={refundQuantity <= 0}>
          <Coins weight="light" size={24} />
          <FormatPrice currency={currency}>{refundQuantity}</FormatPrice>
          {refundMethod && ` (${t(refundMethodText[refundMethod])})`}
        </Styles.RefundQuantity>
      )}
      {allowIssueRefund && (
        <IssueRefundComboBox checked={checked} onChange={onChange} canEditIssueRefund={canEditIssueRefund} />
      )}
      {!allowIssueRefund && !isInstant && (
        <>
          <Text type="bodyMRegular" color={theme.colors.warning.onSurface}>
            {t(
              'No es posible procesar el reembolso desde Reveni debido a limitaciones de la pasarela de pago. Será necesario emitirlo manualmente desde tu plataforma de comercio electrónico.'
            )}
          </Text>
          {exchangeForOrderExternalUrl && (
            <Text type="bodyMRegular" color={theme.colors.warning.onSurface}>
              {t('Puedes procesar el reembolso utilizando este ')}{' '}
              <Link to={exchangeForOrderExternalUrl}>{t('enlace')}</Link>.
            </Text>
          )}
        </>
      )}
    </Styles.Container>
  )
}

export default IssueRefundSelector
